// BOLDE-owned (house) — safe to edit on the draft; follow lp/docs/NAMING-STANDARD.md.
$(document).ready(function () {
  /* Swiper loads only on pages whose sections print Swiper markup (layout/theme.liquid). */
  var hasSwiper = typeof window.Swiper === "function";

  /* Smooth-scroll to the buy box. With no buy box on the page the link keeps its own href. Delegated: the header's
     SHOP NOW is re-rendered after load, so a handler bound to it at ready was lost and it fell back to a plain
     anchor jump (2026-10-22). */
  $(document).on("click", 'a[href="#buyBolde"], .bolde_btn-main, .bolde_header-btn', (e) => {
      let target = $("#buyBolde");
      if (!target.length) {
        target = $("#bottles");
      }

      if (!target.length) return;
      e.preventDefault();

      /* lp-buybox pages: one landing point for every SHOP NOW (sections/lp-buybox.liquid, Alex 2026-10-22) */
      if (target.is("#buyBolde") && typeof window.lpScrollToBuyBox === "function") return window.lpScrollToBuyBox();

      const offset = target.offset().top - 64;
      $("html, body").animate({ scrollTop: offset }, 400);
    }
  );

  $('a[href="#judgeme_product_reviews"]').on("click", function (e) {
    e.preventDefault();
    const target = $("#judgeme_product_reviews");
    if (!target.length) return;
    const preferredOffset = Number($(this).data("offset")) || 100;
    const offset = target.offset().top - preferredOffset;
    $("html, body").animate({ scrollTop: offset }, 400);
  });

  /* Gallery swipers are built lazily: shop-now renders one gallery per variant (63) but shows one. A gallery
     is initialized the first time it is visible (at ready, or when anything removes .hidden), which also
     gives Swiper real dimensions instead of a display:none box. */
  function initGallery(el) {
    if (el.dataset.swiperInit) return;
    var $container = $(el);
    var $thumbs = $container.find(".gallery-thumbs")[0];
    var $main = $container.find(".main-gallery")[0];
    var $nextBtn = $container.find(".swiper-button-next")[0];
    var $prevBtn = $container.find(".swiper-button-prev")[0];
    /* An lp-buybox lazy gallery is an empty stub until its slides are built: mark it initialized only once
       it has slides, so a stub revealed before it is filled is built later. */
    if (!$thumbs || !$main || !hasSwiper) return;
    el.dataset.swiperInit = "1";

    /* data-thumbs="horizontal" is lp-buybox's gallery_layout: below (thumbs under the stage, no arrows).
       The thumbnail strip never loops (it is a scrollable row). The big photo loops (2026-10-20, Alex: swipe past the
       last photo to get back to the first, like the side layout): Swiper 11 loops by moving slides, not cloning them, and
       its thumbs module maps by realIndex, so the active outline stays right. Galleries of 1-2 photos don't loop. */
    if (el.dataset.thumbs === "horizontal") {
      var galleryThumbsBelow = new Swiper($thumbs, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        direction: 'horizontal',
        loop: false,
        slideToClickedSlide: true,
        observer: true,
        /* Not the parents (they include <body>, so app elements re-measured the carousel); resizeObserver catches a reveal. */
        observeParents: false,
        resizeObserver: true,
      });

      new Swiper($main, {
        spaceBetween: 8,
        loop: $main.querySelectorAll(".swiper-slide").length > 2,
        grabCursor: true,
        observer: true,
        observeParents: false,
        resizeObserver: true,
        thumbs: {
          swiper: galleryThumbsBelow,
        },
      });
      return;
    }

    var galleryThumbs = new Swiper($thumbs, {
      spaceBetween: 8,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      direction: "vertical",
      loop: true,
    });

    new Swiper($main, {
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: $nextBtn,
        prevEl: $prevBtn,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
      // No pagination here: a global .swiper-pagination selector would bind every gallery to the add-ons dots.
    });
  }
  $(".bb-product_gallery_flex").each(function () {
    if (!this.classList.contains("hidden")) initGallery(this);
  });
  if (window.MutationObserver) {
    var galleryObserver = new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === "attributes" && !r.target.classList.contains("hidden")) initGallery(r.target);
      });
    });
    $(".bb-product_gallery_flex").each(function () {
      galleryObserver.observe(this, { attributes: true, attributeFilter: ["class"] });
    });
  } else {
    $(".bb-product_gallery_flex").each(function () { initGallery(this); });
  }
  /* Theme editor: a settings change re-renders the section with fresh gallery markup; build its sliders too (without
     this the editor preview showed unbuilt strips, e.g. thumbnails with no gaps). */
  document.addEventListener("shopify:section:load", function (e) {
    $(e.target).find(".bb-product_gallery_flex").each(function () {
      if (galleryObserver) galleryObserver.observe(this, { attributes: true, attributeFilter: ["class"] });
      if (!this.classList.contains("hidden")) initGallery(this);
    });
  });

  $(".bolde_upsell-nav-next-mob").click(function () {
    $(".bolde_upsell-nav-next").trigger("click");
  });

  $(".bolde_carro-faq-block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bolde_carro-faq-content").slideToggle();
  });

  $(".bolde_upsell-nav-prev-mob").click(function () {
    $(".bolde_upsell-nav-prev").trigger("click");
  });

  /* Keyboard and screen-reader access for the color swatches (<div>s): role, tabindex, aria, and Enter/Space
     fire the same native click, so every other click listener (Intelligems included) keeps working. */
  function swatchA11y() {
    var $sw = $(this);
    if (!$sw.attr("role")) $sw.attr("role", "button");
    if (!$sw.attr("tabindex")) $sw.attr("tabindex", "0");
    if (!$sw.attr("aria-label")) {
      var label = $sw.attr("data-title") || "";
      var size = $sw.attr("data-size");
      $sw.attr("aria-label", size ? label + ", " + size + " oz" : label);
    }
    $sw.attr("aria-pressed", $sw.hasClass("active") ? "true" : "false");
  }
  function swatchKey(e) {
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      this.click();
    }
  }
  $(".bb-product-color_box").each(swatchA11y).on("keydown", swatchKey);

  function swatchClick() {
    $(this).addClass('active');
    $('.bb-product-color_box').removeClass('active');
    $('.bb-product-atc_primary').prop('disabled', false);
    $('.bb-product-atc_primary').removeClass('disabled');
    $('.atc_text').text('ADD TO CART');
    $(this).addClass("active");
    $('.bb-product-color_box').attr('aria-pressed', 'false');
    $(this).attr('aria-pressed', 'true');
    var currentId = $(this).attr('data-id');
    $('.bb-product-atc_primary').attr('data-id', currentId);
    document.dispatchEvent(new CustomEvent('stylux:variant-changed', {
      detail: {
        variantId: currentId
      },
      bubbles: true
    }));

    var currentTitle = $(this).attr("data-title");
    var currentTag = $(this).attr("data-var-tag");
    $('.bb-product__color').html(currentTitle);
    if (currentTag && currentTag.trim() !== "") {
        $('.bb-product__tag').html(currentTag).css('display', 'inline');
    } else {
        $('.bb-product__tag').css('display', 'none');
    }

    $('.bb-price_line').addClass('hidden');
    $('.bb-price_line[data-id="' + currentId + '"]').removeClass('hidden');

    $('.bb-product_gallery_flex').addClass('hidden');
    $('.bb-product_gallery_flex[data-id="' + currentId + '"]').removeClass('hidden');

    var currentAvailable = $('.bb-price_line[data-id="' + currentId + '"]').attr('data-available');
    if (currentAvailable == "true") {
      $('.bb-product_atc').find('.atc_text').html('ADD TO CART');
    } else {
      $('.bb-product_atc').find('.atc_text').html('SOLD OUT');
    }
  }
  $('.bb-product-color_box').click(swatchClick);
  /* Theme editor only (shopify:section:load never fires on the storefront): a settings change re-renders the buy box
     with fresh swatches that the page-load binding above never saw, so wire the new ones the same way (2026-10-29). */
  document.addEventListener("shopify:section:load", function (e) {
    $(e.target).find(".bb-product-color_box").each(swatchA11y).on("keydown", swatchKey).on("click", swatchClick);
  });

  $('.kit-selection-options input[type="radio"]').change(function () {
    if($(this).val() == 'single') {
      $('.single-kit-section').addClass('active');
      $('.bundle-kit-section').removeClass('active');
      $('.bb-addons_container').show();
      $('.first_var_single_select').trigger('click');
      $('.first_var_single_select').addClass('active');
      $('.kit-label').removeClass('kit_active');
      $(this).parent().addClass('kit_active');
      $('.parent_vs_content_hs').hide();
      $('.show_default').removeClass('hidden');
    } else {
      $('.bundle-kit-section').addClass('active');
      $('.single-kit-section').removeClass('active');
      $('.bb-addons_container').hide();
      $('.first_var_kit_select').trigger('click');
      $('.first_var_kit_select').addClass('active');
      $('.kit-label').removeClass('kit_active');
      $(this).parent().addClass('kit_active');
      $('.parent_vs_content_hs').show();
      $('.show_default').addClass('hidden');
    }
  });

  $(".bb-addons_container.v2 .bb-addons_cell").click(function (e) {
    const isActive = $(this).hasClass("active");
    $(this).toggleClass("active");
    $(this).find(".bb-addons__toggle-checkbox").prop("checked", !isActive);
  });

  $(".bb-addon_info").click(function (e) {
    e.stopPropagation();
    var currentId = $(this).attr("data-id");
    $('.bb_addon-popup[data-id="' + currentId + '"]').css("display", "flex");
  });
  $(".bb_addon-popup").click(function () {
    $(".bb_addon-popup").hide();
  });

  $(".bb_accordion-tab").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bb_accordion-content").slideToggle();
  });

  $(".bolde_faq-line").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bolde_faq-content").slideToggle();
  });

  if (hasSwiper) new Swiper(".swiper.bolde-reviews_carousel", {
    loop: true,
    spaceBetween: 32,
    slidesPerView: 3,

    navigation: {
      nextEl: ".bolde-reviews_carousel-outer .swiper-button-next",
      prevEl: ".bolde-reviews_carousel-outer .swiper-button-prev",
    },
    pagination: {
      el: ".bolde_reviews.swiper-pagination",
      // Decorative dots (too close to give 44px targets); the arrows are the controls.
      clickable: false,
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  /* Add-ons carousel: slides per view comes from the container width (~180px per card), and loop is on only
     when there are enough slides for Swiper's loop mode. Selectors resolve inside each container so several
     carousels on one page do not fight over the dots. */
  var addonsSwipers = [];

  function addonsPerView(el, count) {
    var w = el.clientWidth || 0;
    /* Add-ons block, Layout = Carousel: 2 cards on phones, 2.3 above. */
    if (el.getAttribute("data-lp-addons-layout") === "carousel") {
      return w && w < 500 ? 2 : 2.3;
    }
    if (!w) return 2.3; // hidden at init (kit toggle); the resize pass corrects it
    var spv = Math.round((w / 180) * 10) / 10; // ~180px target card width
    spv = Math.max(2.3, Math.min(3.4, spv));
    // If everything all but fits, show it all (no pointless nudge); cards stay at most ~240px wide.
    if (count && count - spv < 0.35) return Math.max(count, w / 240);
    return spv;
  }

  function initAddonsCarousels() {
    if (!hasSwiper) return;
    var containers = document.querySelectorAll(".bb-addons_container.v2.swiper");
    Array.prototype.forEach.call(containers, function (el) {
      if (el.swiper) return;
      /* Layout = Grid: laid out by the buy-box stylesheet, no carousel. */
      if (el.getAttribute("data-lp-addons-layout") === "grid") return;
      var count = el.querySelectorAll(".bb-addons_cell").length;
      var perView = addonsPerView(el, count);
      addonsSwipers.push(
        new Swiper(el, {
          spaceBetween: 12,
          slidesPerView: perView,
          roundLengths: true,   /* whole-pixel cards (Alex 2026-10-22): 361px across 2 was 176.5 each */
          loop: count >= Math.ceil(perView) * 2,
          watchOverflow: true,
          observer: true,
          /* Not the parents (<body> included): Swiper's resizeObserver catches a hidden container shown. */
          observeParents: false,
          navigation: {
            nextEl: el.querySelector(".bb-addons_header-btns .swiper-button-next"),
            prevEl: el.querySelector(".bb-addons_header-btns .swiper-button-prev"),
          },
          pagination: {
            el: el.querySelector(".bb-addons_header-btn-dots.swiper-pagination"),
            /* .lp-upsells dots are decorative (too close for 44px targets); clickable:false keeps Swiper from
               giving them role="button". The arrows and swipe do the paging. */
            clickable: !el.classList.contains("lp-upsells"),
          },
        })
      );
    });
  }

  initAddonsCarousels();

  var addonsResizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(addonsResizeTimer);
    addonsResizeTimer = setTimeout(function () {
      addonsSwipers.forEach(function (sw) {
        if (!sw || sw.destroyed || !sw.el) return;
        var perView = addonsPerView(sw.el, sw.slides ? sw.slides.length : 0);
        if (sw.params.slidesPerView !== perView) {
          sw.params.slidesPerView = perView;
          sw.update();
        }
      });
    }, 200);
  });

  $(".bolde_youtube-popup-close").click(function () {
    $(".bolde_youtube-popup-outer").hide();
  });

  $(".bolde_product-video-trigger").click(function () {
    // The player iframe ships with data-src so YouTube loads only on this click, not on page load.
    $(".bolde_youtube-popup-outer iframe[data-src]").each(function () {
      if (!this.getAttribute("src")) this.setAttribute("src", this.getAttribute("data-src"));
    });
    $(".bolde_youtube-popup-outer").css("display", "flex");
  });

  $(".first_var_kit_select").trigger("click");
  $(".first_var_kit_select").addClass("active");
  $(".bb-addons_container.hide_default").hide();

  $(".bolde_header-nav-cell").click(function () {
    $(".bolde_header-nav-cell").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data-id");
    $(".bb-section-outer.boldeBottle_grid").hide();
    $(".bb-section-outer.boldeBottle_coll").hide();
    if (data == "all") {
      $(".bb-section-outer.boldeBottle_grid").show();
      $(".bb-section-outer.boldeBottle_coll").show();
    } else {
      $('.bb-section-outer.boldeBottle_grid[id="' + data + '"]').show();
      $('.bb-section-outer.boldeBottle_coll[id="' + data + '"]').show();
    }
  });
});
